/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ProductClasType = {
    Rsk: 'RSK',
    Ul: 'UL',
    RskUl: 'RSK_UL',
    PseudoRsk: 'PSEUDO_RSK'
} as const;
export type ProductClasType = typeof ProductClasType[keyof typeof ProductClasType];


export function instanceOfProductClasType(value: any): boolean {
    for (const key in ProductClasType) {
        if (Object.prototype.hasOwnProperty.call(ProductClasType, key)) {
            if (ProductClasType[key as keyof typeof ProductClasType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ProductClasTypeFromJSON(json: any): ProductClasType {
    return ProductClasTypeFromJSONTyped(json, false);
}

export function ProductClasTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductClasType {
    return json as ProductClasType;
}

export function ProductClasTypeToJSON(value?: ProductClasType | null): any {
    return value as any;
}

export function ProductClasTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ProductClasType {
    return value as ProductClasType;
}

